import { Button, Checkbox, Container } from "@mui/material";
import Heading from "../Heading";
import ArrowBackIcon from "assets/icons/ArrowBackIcon";
import { useNavigate, useParams } from "react-router-dom";
import Form from "./Form";
import ProductsTable from "./ProductsTable";
import { createContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { apiGetWarehouseHandling, apiSetWarehouseHandling } from "api/warehouseApi";

export const STContext = createContext<any>(null);

export default function AddStockTacking() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [main, setMain] = useState<any>();
  const [products, setProducts] = useState<any>();
  const [billCreate, setBillCreate] = useState(false);
  const [warehouseHandling, setWarehouseHandling] = useState<any>();
  const token = useSelector((state: any) => state.businessReducer.business.token);

  useEffect(() => {
    if (id) {
      dispatch(
        // @ts-ignore
        apiGetWarehouseHandling({ token, id }, (res: any) => {
          setWarehouseHandling(res.warehouseHandling);
        })
      );
    }
  }, [token, id]);

  function handleChange(num: number) {
    const s = ["during", "finished"];
    let m = { ...main, billCreate };
    if (s[num]) m = { ...main, status: s[num], billCreate };
    const data = {
      main: m,
      products,
    };
    let fd: any = { data, token };
    if (id) fd = { ...fd, id };
    dispatch(
      // @ts-ignore
      apiSetWarehouseHandling(fd, (res: any) => {
        navigate("/stockTaking");
      })
    );
  }

  return (
    <STContext.Provider value={warehouseHandling}>
      <Container maxWidth={"lg"}>
        <Heading mainText="انبار گردانی" subText="لیست انبارگردانی های انجام شده">
          <Button variant="text" style={{ color: "#7D96B8", gap: "10px" }} onClick={() => navigate(-1)}>
            <ArrowBackIcon color="#7D96B8" />
            <span>بازگشت به لیست</span>
          </Button>
        </Heading>
        <Form onChange={(x) => setMain(x)} />
        <div style={{ width: "100%", height: 24 }} />
        <ProductsTable mainData={main} onChange={(x) => {
          setProducts(x)
        }} />
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            gap: 24,
            padding: "12px 24px",
            backgroundColor: "#fff",
            borderRadius: 4,
            marginBottom: 48,
          }}
        >
          <div className="flex items-center">
            <span>ایجاد حواله انبار</span>
            <Checkbox checked={billCreate} onClick={() => setBillCreate((x) => !x)} />
          </div>
          {id ? (
            <>
              <Button
                style={{ minWidth: 160, borderRadius: 6 }}
                variant="outlined"
                onClick={() => handleChange(2)}
              >
                ویرایش
              </Button>
            </>
          ) : (
            <>
              <Button
                style={{ minWidth: 160, borderRadius: 6 }}
                variant="outlined"
                onClick={() => handleChange(0)}
              >
                ثبت پیش نویس
              </Button>

            </>

          )}
          <Button
            style={{ minWidth: 160, borderRadius: 6 }}
            variant="contained"
            onClick={() => handleChange(1)}
          >
            ثبت نهایی
          </Button>
        </div>
      </Container>
    </STContext.Provider>
  );
}
